module.exports = __webpack_public_path__ + "static/browser-extension-desktop-698209d1380f7253604583b109161336.png";